import { Box, Button, Group, Modal, Text, TextInput } from "@mantine/core";
import { deleteUser } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { appShowNotification } from "../../utils/utils";

interface deleteAccountProps {
  modalOpened: boolean;
  setModalOpened: (val: boolean) => void;
}
const DeleteAccountModal = ({
  modalOpened,
  setModalOpened
}: deleteAccountProps) => {
  const [deleteField, setDeleteField] = useState("");
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    (async () => {
      setDeleteField("");
    })();
  }, []);
  const handleDeleteAccount = async () => {
    if (deleteField === "DELETE") {
      setLoading(true);
      try {
        // delete patient data from database
        const result = await deleteUser();
        console.log(result);
        setLoading(false);
      } catch (error) {
        console.log("error deleting user", error);
      }
    } else {
      appShowNotification({
        type: "error",
        title: "Please type DELETE to confirm"
      });
    }
  };

  return (
    <Modal
      opened={modalOpened}
      onClose={() => {
        setModalOpened(false);
      }}
      title="Delete account"
    >
      <Box
        style={{
          backgroundColor: "black",
          borderRadius: 10,
          marginBottom: 16,
          padding: 10
        }}
      >
        <Text
          style={{
            fontWeight: "bold",
            fontSize: 16,
            color: "white"
          }}
        >
          Are you sure you want to DELETE your Manta Classic account?
        </Text>
        <Text style={{ fontSize: 16, marginVertical: 16, color: "white" }}>
          This will log you out on all devices and delete all of your account
          information. This cannot be undone.
        </Text>
      </Box>
      <Text fw={"bold"}>Type DELETE below</Text>
      <TextInput
        placeholder="Enter DELETE here"
        value={deleteField}
        onChange={(e) => setDeleteField(e.target.value)}
      />
      <Group mt="md">
        <Group mt="md">
          <Button loading={loading} onClick={() => setModalOpened(false)}>
            Cancel
          </Button>
          <Button color={"red"} loading={loading} onClick={handleDeleteAccount}>
            Delete
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};
export default DeleteAccountModal;
